<template>
    <table class="table table-bordered">
        <tr>
            <th>Days</th>
            <th>Min</th>
            <th>Max</th>
            <th>Avg</th>
        </tr>
        <tr v-for="dailyData in data.slice().reverse()">
            <th >{{ dailyData.day }}</th>
            <template>
                <td>{{dailyData.minstring}}</td>
                <td>{{dailyData.maxstring}}</td>
                <td>{{dailyData.avgstring}}</td>
            </template>
        </tr>
    </table>
</template>

<script>
export default {
    props : ["data"]
}
</script>

<style scoped>
    th, td{
        text-align: center;
    }
</style>